import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import AdminLayout from "../../layouts/Admin";
import AdminMenu from "../../adminPages/adminMenu";
import Candidates from "../../candidates";
import ManageClients from "../../clients/manageClients/manageClients";
import GenericAccountDetails from "../../genericAccounts/genericAccountDetailScreen/accountDetailsScreen";
import UserDetails from "../../users/userDetails";
import CandidateProfile from "../../candidate/ProfileDetails";
import AddManageGenericAccount from "../../genericAccounts/addManageGenericAccounts/addManageGA";
import ClientsProfile from "../../clients/manageClients/clientProfile";
import EditExistingClients from "../../clients/manageClients/editExistingClient";
import CreateNewUser from "../../users/createNewUser";

import EditSystemMessage from "../../systemMessages/editSystemMessage";
import SearchSystemMessage from "../../systemMessages/searchSystemMessage";

import HomeAccountTeamMembers from "../components/rtiSetUp/accountTeamMembers/HomeAccountTeamMembers";
import CreateAccountTeamMembers from "../components/rtiSetUp/accountTeamMembers/createAccountTeamMembers/CreateAccountTeamMembers";
import EditAccountTeamMembersHome from "../components/rtiSetUp/accountTeamMembers/editAccountTeamMenber/EditAccountTeamMembersHome";

import ClientAccountHome from "../components/rtiSetUp/manageClientAccount/clientAccount/ClientAccountHome";
import CreateClientAccount from "../components/rtiSetUp/manageClientAccount/clientAccount/createClientAccount/CreateClientAccount";
import ClientSubAccountHome from "../components/rtiSetUp/manageClientAccount/clientSubAccount/ClientSubAccountHome";
import CreateClientSubAccount from "../components/rtiSetUp/manageClientAccount/clientSubAccount/createClientSubAccount/CreateClientSubAccount";
import EditClientSubAccountHome from "../components/rtiSetUp/manageClientAccount/clientSubAccount/editClientSubAccount/EditClientSubAccountHome";
import ClientSpecificReportHome from "../components/rtiSetUp/reportAndResources/clientSpecificReports/ClientSpecificReportHome";
import ThoughtLeadershipResourcesHome from "../components/rtiSetUp/reportAndResources/thoughtLeadershipResources/ThoughtLeadershipResourcesHome";
import CreateClientSpecificReport from "../components/rtiSetUp/reportAndResources/clientSpecificReports/createClientSpecificReport/CreateClientSpecificReport";

import MeetingRequestHome from "../components/rtiSetUp/meetingRequests/MeetingRequestHome";
import AdminMessageHome from "../components/rtiSetUp/adminMessages/AdminMessageHome";
import CreateAdminMessage from "../components/rtiSetUp/adminMessages/createAdminMessage/CreateAdminMessage";
import EditAdminMessageHome from "../components/rtiSetUp/adminMessages/editAdminMessage/EditAdminMessageHome";

import ClientUserHome from "../components/rtiSetUp/clientUser/ClientUserHome";
import CreateClientUser from "../components/rtiSetUp/clientUser/createClientUser/CreateClientUser";
import EditClientUserHome from "../components/rtiSetUp/clientUser/editClientUser/EditClientUserHome";
import EditMeetingRequestHome from "../components/rtiSetUp/meetingRequests/editMeetingRequests/EditMeetingRequestHome";
import EditClientAccountHome from "../components/rtiSetUp/manageClientAccount/clientAccount/editClientAccount/EditClientAccountHome";
import AssignReferralReqHome from "../components/rtiSetUp/referrals/assignReferralReq/AssignReferralReqHome";
import ManageReferralReqHome from "../components/rtiSetUp/referrals/manageReferralReq/ManageReferralReqHome";

import EditAssignReferralReqHome from "../components/rtiSetUp/referrals/assignReferralReq/editAssignReferralReq/EditAssignReferralsHome";
import EditManageReferralReqHome from "../components/rtiSetUp/referrals/manageReferralReq/editManageReferralReq/EditManageReferralReqHome";
import EditClientSpecificReportHome from "../components/rtiSetUp/reportAndResources/clientSpecificReports/editClientSpecificReport/EditClientSpecificReportHome";
import EditThoughtLeadershipResourcesHome from "../components/rtiSetUp/reportAndResources/thoughtLeadershipResources/editThoughtLeadershipResources/EditThoughtLeadershipResourcesHome";
import CommonButtonHeader from "../components/rtiSetUp/manageClientAccount/CommonButtonHeader";
import ReportAndResourcesHeader from "../components/rtiSetUp/reportAndResources/ReportAndResourcesHeader";
import ReferralHeader from "../components/rtiSetUp/referrals/ReferralHeader";
import NotFoundComp from "./NotFoundComp";
import ProtectedClientPortalSettingRoutes from "./ProtectedClientPortalSettingRoutes";
import ProtectedGetUserDetailsRoutes from "./ProtectedGetUserDetailsRoutes";
import { getAccessTypes } from "../hooksAndFunctions/functions/getAccessTypes";
import ProgrammeDescriptorHeader from "../components/rtiSetUp/programmeDescriptor/ProgrammeDescriptorHeader";
import EditProgrammeDescriptorHome from "../components/rtiSetUp/programmeDescriptor/manageProgrammeDescriptor/editProgrammeDescriptor/EditProgrammeDescriptorHome";
import ProgrammeDescriptorHome from "../components/rtiSetUp/programmeDescriptor/manageProgrammeDescriptor/ProgrammeDescriptorHome";
import CreateProgrammeDescriptor from "../components/rtiSetUp/programmeDescriptor/manageProgrammeDescriptor/createProgrammeDescriptor/CreateProgrammeDescriptor";
import ClientAccPDHome from "../components/rtiSetUp/programmeDescriptor/clientAccProgrammeDescriptor/ClientAccPDHome";
import EditClientAccPDHome from "../components/rtiSetUp/programmeDescriptor/clientAccProgrammeDescriptor/editClientAccPD/EditClientAccPDHome";
import CreateClientAccPD from "../components/rtiSetUp/programmeDescriptor/clientAccProgrammeDescriptor/createClientAccPD/CreateClientAccPD";
import AdminUserHome from "../components/rtiSetUp/adminUsers/AdminUserHome";
import CreateAdminUser from "../components/rtiSetUp/adminUsers/createAdminUser/CreateAdminUser";
import EditAdminUserHome from "../components/rtiSetUp/adminUsers/editAdminUser/EditAdminUserHome";
import ResourceFolderStructureHome from "../components/rtiSetUp/programmeDescriptor/resourceFolderStructure/ResourceFolderStructureHome";
import UploadAndCreateCustomPD from "../components/rtiSetUp/programmeDescriptor/uploadAndCreateCustomPD/UploadAndCreateCustomPD";


const RoutesComp = () => {

  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location])

  const { clientPortalAdminType,
  } = getAccessTypes()

  const {
    hasA2Access,
    hasA3Access
  } = clientPortalAdminType

  // console.log("access:", clientPortalAdminType)

  return (
    <Routes>
      {/* <Route element={<AuthProtectedRoute />} > */}
      <Route element={<ProtectedGetUserDetailsRoutes />} >
        <Route path="/" element={<AdminLayout />}>
          <Route path="/" element={<AdminMenu />} />
          <Route path="/dashboard" element={<AdminMenu />} />

          <Route path="/candidates" element={<Candidates />} />
          {/* <Route path="/users" element={<UserAccounts />} /> */}

          {/* <Route path="/users" element={<AdminUserHome />} /> */}

          <Route path="/clients" element={<ManageClients />} />
          <Route
            path="/generic-accounts-details"
            element={<GenericAccountDetails />}
          />
          <Route path="/user-details" element={<UserDetails />} />
          <Route path="/candidateProfile" element={<CandidateProfile />} />
          <Route
            path="/add-manage-generic-accounts"
            element={<AddManageGenericAccount />}
          />
          <Route path="/clients-profile" element={<ClientsProfile />} />
          <Route
            path="/edit-existing-clients"
            element={<EditExistingClients />}
          />
          <Route path="/createNewUser" element={<CreateNewUser />} />

          <Route path="/systemMessage" >
            <Route path="search" element={<SearchSystemMessage />} />
            <Route path="edit" element={<EditSystemMessage />} />
          </Route>

          <Route path="admin_user">
            <Route index element={<AdminUserHome />} />
            <Route path="view" element={<AdminUserHome />} />
            <Route path="create" element={<CreateAdminUser />} />
            <Route path="edit/:id" element={<EditAdminUserHome />} />
          </Route>

          {/** client portal setting routes */}
          <Route element={<ProtectedClientPortalSettingRoutes />} >
            <Route path="/client_portal_setup">
              {/**All Accounts */}
              <Route path="accounts" element={<CommonButtonHeader />}>
                {/** Allow A2 access change */}
                {/* <Route index element={!!hasA2Access ? <ClientSubAccountHome /> : <ClientAccountHome />} /> */}
                <Route index element={<ClientAccountHome />} />
                {/**client account */}
                <Route path="client_acc">
                  <Route index element={<ClientAccountHome />} />

                  <Route path="view" element={<ClientAccountHome />} />
                  <Route path="create" element={<CreateClientAccount />} />
                  <Route path="edit/:id" element={<EditClientAccountHome />} />
                </Route>

                {/**sub client account group */}
                <Route path="client_sub_acc">
                  <Route index element={<ClientSubAccountHome />} />
                  <Route path="view" element={<ClientSubAccountHome />} />
                  <Route path="create" element={<CreateClientSubAccount />} />
                  <Route path="edit/:id" element={<EditClientSubAccountHome />} />
                </Route>
              </Route>


              {/**reports and resources */}
              <Route path="reports" element={<ReportAndResourcesHeader />}>
                <Route index element={<ClientSpecificReportHome />} />
                {/**client_specific_report */}
                <Route path="client_specific_report">
                  <Route index element={<ClientSpecificReportHome />} />

                  <Route path="view" element={<ClientSpecificReportHome />} />
                  <Route path="create" element={<CreateClientSpecificReport />} />
                  <Route path="edit/:id" element={<EditClientSpecificReportHome />} />
                </Route>

                {/**thought_leadership_resources */}
                <Route path="thought_leadership_resources">
                  <Route index element={<ThoughtLeadershipResourcesHome />} />
                  <Route path="view" element={<ThoughtLeadershipResourcesHome />} />
                  <Route path="edit/:sitecoreId" element={<EditThoughtLeadershipResourcesHome />} />
                </Route>
              </Route>

              {/**programme descriptors */}
              <Route path="programme_descriptor" element={<ProgrammeDescriptorHeader />}>
                <Route index element={<ClientAccPDHome />} />


                {/**client account programme descriptors */}
                <Route path="client_acc_pd">
                  <Route index element={<ClientAccPDHome />} />

                  <Route path="view" element={<ClientAccPDHome />} />
                  <Route path="create" element={<CreateClientAccPD />} />
                  <Route path="edit/:id" element={<EditClientAccPDHome />} />

                  <Route path="addCustomResource/:clientAccountId" element={<UploadAndCreateCustomPD />} />

                  <Route path="folder/view/:id" element={<ResourceFolderStructureHome />} />
                </Route>

                {/**manage programme descriptors */}
                <Route path="manage_acc_pd">
                  <Route index element={<ProgrammeDescriptorHome />} />

                  <Route path="view" element={<ProgrammeDescriptorHome />} />
                  <Route path="create" element={<CreateProgrammeDescriptor />} />
                  <Route path="edit/:id" element={<EditProgrammeDescriptorHome />} />
                   <Route path="recycle" element={<ProgrammeDescriptorHome />} />
                </Route>
              </Route>

              {/**referrals */}
              <Route path="referrals" element={<ReferralHeader />}>
                <Route index element={!!hasA2Access || hasA3Access ? <ManageReferralReqHome /> : <AssignReferralReqHome />} />
                {/**assign referral requests */}
                <Route path="assign_referral_req">
                  <Route index element={<AssignReferralReqHome />} />
                  <Route path="view" element={<AssignReferralReqHome />} />
                  <Route path="edit/:Id" element={<EditAssignReferralReqHome />} />
                </Route>

                {/**manage referral requests */}
                <Route path="manage_referral_req">
                  <Route index element={<ManageReferralReqHome />} />
                  <Route path="view" element={<ManageReferralReqHome />} />
                  <Route path="edit/:Id" element={<EditManageReferralReqHome />} />
                </Route>
              </Route>

              {/**account team member */}
              <Route path="acc_team">
                <Route index element={<HomeAccountTeamMembers />} />
                <Route path="view" element={<HomeAccountTeamMembers />} />
                <Route path="create" element={<CreateAccountTeamMembers />} />
                <Route path="edit/:Id" element={<EditAccountTeamMembersHome />} />
              </Route>

              {/**meeting requests */}
              <Route path="meeting_requests">
                <Route index element={<MeetingRequestHome />} />
                <Route path="view" element={<MeetingRequestHome />} />
                <Route path="edit/:Id" element={<EditMeetingRequestHome />} />
              </Route>

              {/**admin messages */}
              <Route path="admin_messages">
                <Route index element={<AdminMessageHome />} />
                <Route path="view" element={<AdminMessageHome />} />
                <Route path="create" element={<CreateAdminMessage />} />
                <Route path="edit/:Id" element={<EditAdminMessageHome />} />
              </Route>

              {/**client users */}
              <Route path="client_users">
                <Route index element={<ClientUserHome />} />
                <Route path="view" element={<ClientUserHome />} />
                <Route path="create" element={<CreateClientUser />} />
                <Route path="edit/:Id" element={<EditClientUserHome />} />
              </Route>



            </Route>
          </Route>
        </Route>

        <Route path="*" element={<NotFoundComp />} />
      </Route>
      {/* </Route> */}
    </Routes >
  );
};
export default RoutesComp;
